import type { AuthUser, Company } from '@kanda-libs/ks-frontend-services';
import type { ContractRequestBodyBody } from '@kanda-libs/ks-frontend-services/src/service/external';
import { formatDateToMonthDateString } from 'utils';
import { formatAddress } from 'utils/Address-functions';

const getCompanyName = (company: Company): string => {
  if (!company) return 'No company name';
  if (company.company_type === 'sole_trader') {
    return (
      company.sole_trader_info?.trading_name ??
      company.contact_info?.trading_name ??
      'No trading name given'
    );
  }
  return (
    company.limited_company_info?.company_name ??
    company.contact_info?.trading_name ??
    'No company name given'
  );
};

const getCompanyAddress = (company: Company): string => {
  const address =
    company?.limited_company_info?.company_address ||
    company?.sole_trader_info?.trading_address;
  return formatAddress(address);
};

const getCompanyIdentifier = (
  company: Company,
  me: AuthUser,
  signee?: string,
): string => {
  if (!company) return 'No company identifier';
  if (company.company_type === 'sole_trader') {
    if (!me) return 'No trader name';
    return signee ?? me.name;
  }
  return company.limited_company_info?.company_number ?? 'No company number';
};

export const formatTermsBody = (
  company: Company | null,
  me: AuthUser | undefined,
  fingerprint: string,
  signee?: string,
): ContractRequestBodyBody | undefined => {
  if (!company || !me) return undefined;

  const currentDate = formatDateToMonthDateString(new Date());

  const companyName = getCompanyName(company);
  const companyAddress = getCompanyAddress(company);
  const companyIdentifier = getCompanyIdentifier(company, me, signee);

  return {
    currentDate,
    fingerprint,
    companyName,
    companyAddress,
    companyIdentifier,
    companyType: company.company_type,
    signee: signee || me.name,
    signeeEmail: me.email,
  };
};
